import { TASHKENT_UTC_OFFSET_MIN } from './constants.ts';

const OFFSET_MS = TASHKENT_UTC_OFFSET_MIN * 60_000;
const DAY_MS = 24 * 60 * 60_000;

/** Start of the Tashkent calendar day containing `at`, as a UTC Date. */
export function tashkentDayStart(at: Date): Date {
  const local = at.getTime() + OFFSET_MS;
  return new Date(local - (local % DAY_MS) - OFFSET_MS);
}

/** [start, end) of the Tashkent calendar day containing `at`. */
export function tashkentDayRange(at: Date): { start: Date; end: Date } {
  const start = tashkentDayStart(at);
  return { start, end: new Date(start.getTime() + DAY_MS) };
}

/** The moment `HH:MM` Tashkent time happens on the Tashkent day containing `at`. */
export function tashkentTimeOnDay(at: Date, hhmm: string): Date {
  const match = /^([01]\d|2[0-3]):([0-5]\d)$/.exec(hhmm);
  if (!match) throw new Error(`Invalid HH:MM time: ${hhmm}`);
  const [, h, m] = match;
  return new Date(tashkentDayStart(at).getTime() + (Number(h) * 60 + Number(m)) * 60_000);
}

/** Tashkent-local hour (0–23), used for the time-of-day greeting. */
export function tashkentHour(at: Date): number {
  return new Date(at.getTime() + OFFSET_MS).getUTCHours();
}

/** Tashkent calendar date as `YYYY-MM-DD` (idempotency keys for daily jobs). */
export function tashkentDateKey(at: Date): string {
  return new Date(at.getTime() + OFFSET_MS).toISOString().slice(0, 10);
}

/** ISO weekday in Tashkent: 1 = Monday … 7 = Sunday. */
export function tashkentWeekday(at: Date): number {
  const day = new Date(at.getTime() + OFFSET_MS).getUTCDay();
  return day === 0 ? 7 : day;
}
